import { render, staticRenderFns } from "./FormPartLegalEntity.vue?vue&type=template&id=7670d409&scoped=true"
import script from "./FormPartLegalEntity.vue?vue&type=script&lang=js"
export * from "./FormPartLegalEntity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7670d409",
  null
  
)

export default component.exports